module.exports = __webpack_public_path__ + "img/Rob.d54a5072.png";